module.exports = "/_next/static/images/pr-42b0ade2d27b58e73a1d3a49fa5f68b8.svg";